// extracted by mini-css-extract-plugin
var _1 = "BillingEmailCard-module__field--Y4Vaf";
var _2 = "BillingEmailCard-module__fieldContainer--vQgdl";
export { _1 as "field", _2 as "fieldContainer" }
